






























import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      isActive: false,
      menuHeight: null,
      overflow: null,
      menuRef: null
    };
  },
  props: {
    title: {
      type: String
    },
    itemId: {
      type: [String, Number],
      required: true
    },
    drageClass: {
      type: [String, Array]
    },
    dragable: {
      type: Boolean,
      default: false
    },
    drageAnimation: {
      type: Number,
      default: 300
    },
    tag: {
      type: String,
      default: "div"
    },
    drageHandler: {
      type: String
    },
    activate: {
      type: Boolean
    },
    list: {
      type: Array,
      default: (): Array<any> => []
    },
    dragGroup: {
      type: String,
      validator() {
        if (this.dragable) {
          return true;
        }
        return false;
      }
    }
  },
  methods: {
    deactivateAll() {
      this.isActive = !this.isActive;
    },
    test(e) {
      console.log(e);
    }
  },
  mounted() {
    this.isActive = this.activate;
  },
  watch: {
    activate() {
      this.isActive = this.activate;
    }
  }
});
